import { CommonEnums } from '../../common.enums';
import { LAttribute } from './lattribute';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { LAttributesUtil } from 'src/app/shared/grids/lattributes/lattributes.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { Attribute } from './attribute';
import { AttributesUtil } from '../../grids/attributes/attributes.util';
import { Data_Cleanse_Inst } from './data_cleanse_inst';

export class DataCleanse {
    datacleanse_Inst: Data_Cleanse_Inst;
    attributes: Array<Attribute>;

    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    fldr_Id: number;
    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: string;
    is_In_SubFlow: string;
    sel_Run_PropertyType_Cd: string;

    change_Ind: string;
    gen_Tab_Change_Ind: string;
    attr_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefault()
    }

    setDefault(): void {
        this.datacleanse_Inst = new Data_Cleanse_Inst();
        this.attributes = new Array<Attribute>();

        this.nativeDbTyp_Id = CommonEnums.defaults.DEFAULT_INT_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_VAL_NO;

        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.SUCCESS_CODE;
        this.error_Msg = CommonEnums.defaults.SUCCESS_MSG;
    }

    static parse(dataCleanseTmp: DataCleanse): DataCleanse {
        let dataCleanse: DataCleanse = new DataCleanse();
        dataCleanse.copyFrom(dataCleanseTmp);
        return dataCleanse;
    }

    copy(): DataCleanse {
        let dataCleanseTmp: DataCleanse = new DataCleanse();

        dataCleanseTmp.datacleanse_Inst = this.datacleanse_Inst.copy();
        dataCleanseTmp.attributes = AttributesUtil.getInstance().copy(this.attributes);

        dataCleanseTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        dataCleanseTmp.ref_Id = this.ref_Id;
        dataCleanseTmp.ref_Cd = this.ref_Cd;
        dataCleanseTmp.fldr_Id = this.fldr_Id;
        dataCleanseTmp.is_In_SubFlow = this.is_In_SubFlow;

        dataCleanseTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        dataCleanseTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        dataCleanseTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);

        dataCleanseTmp.change_Ind = this.change_Ind;
        dataCleanseTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        dataCleanseTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
        dataCleanseTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        dataCleanseTmp.error_Cd = this.error_Cd;
        dataCleanseTmp.error_Msg = this.error_Msg;

        return dataCleanseTmp;
    }

    copyFrom(dataCleanseTmp: DataCleanse): void {
        this.datacleanse_Inst.copyFrom(dataCleanseTmp.datacleanse_Inst);

        AttributesUtil.getInstance().copyFrom(this.attributes, dataCleanseTmp.attributes);

        this.nativeDbTyp_Id = dataCleanseTmp.nativeDbTyp_Id;
        this.ref_Id = dataCleanseTmp.ref_Id;
        this.ref_Cd = dataCleanseTmp.ref_Cd;
        this.fldr_Id = dataCleanseTmp.fldr_Id;
        this.is_In_SubFlow = dataCleanseTmp.is_In_SubFlow;

        this.sel_Run_PropertyType_Cd = dataCleanseTmp.sel_Run_PropertyType_Cd;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, dataCleanseTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, dataCleanseTmp.runPropertyTypes);

        this.change_Ind = dataCleanseTmp.change_Ind;
        this.gen_Tab_Change_Ind = dataCleanseTmp.gen_Tab_Change_Ind;
        this.attr_Tab_Change_Ind = dataCleanseTmp.attr_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = dataCleanseTmp.rProp_Tab_Change_Ind;

        this.error_Cd = dataCleanseTmp.error_Cd;
        this.error_Msg = dataCleanseTmp.error_Msg;
    }

    compare(dataCleanseTmp: DataCleanse): string {
        let diffString: string = this.datacleanse_Inst.compare(dataCleanseTmp.datacleanse_Inst);
        if( diffString != '') return diffString;

        diffString = this.toBaseCompare(dataCleanseTmp);
        if (diffString != '') return diffString;

        diffString = AttributesUtil.getInstance().compare(this.attributes, dataCleanseTmp.attributes);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.run_Properties, dataCleanseTmp.run_Properties);
        if (diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.runPropertyTypes, dataCleanseTmp.runPropertyTypes);
        if (diffString != '') return diffString;

        return '';
    }

    toBaseCompare(dataCleanseTmp: DataCleanse): string {
        let baseString: string = this.toBaseString();
        let baseTmpString: string = dataCleanseTmp.toBaseString();

        if (baseString != baseTmpString) {
            return baseString + ', ' + baseTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "DataCleanse [datacleanse_Inst=" + this.datacleanse_Inst.toString() + this.toBaseString() +
            ", attributes=" + AttributesUtil.getInstance().toString(this.attributes) +
            ", run_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes=" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind +
                ", error_Cd=" + this.error_Cd + ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd +
                ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind + ", attr_Tab_Change_Ind=" + this.attr_Tab_Change_Ind +
                ", error_Msg=" + this.error_Msg + ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind;
        }

        str += ']';
        return str;
    }

    toBaseString(): string {
        return ", fldr_Id=" + this.fldr_Id + ", nativeDbTyp_Id=" + this.nativeDbTyp_Id +
        ", is_In_SubFlow=" + this.is_In_SubFlow + ", sel_Run_PropertyType_Cd=" + this.sel_Run_PropertyType_Cd;
    }
}